// extracted by mini-css-extract-plugin
export default {"appContainer":"layout_appContainer__7GKhi","mainContent":"layout_mainContent__pQGE7","testimonialSection":"layout_testimonialSection__h0thz"};